<template>
  <div class="useConfiguration">
    <div class="body">
      <div class="nav">
        本功能需新建应用，如需在工具栏设置快捷回复，可以在素材中心复制工具栏URL，详细配置可参考教程。<a
          href=""
          >查看教程</a
        >
      </div>
      <div class="list">
        <div class="name">
          第一步：在企业微信后台创建应用（应用管理-应用-自建-创建应用）
        </div>
        <div class="body-list">
          <el-button type="primary">前往创建应用</el-button>
        </div>
      </div>
      <div class="list">
        <div class="name">第二步：设置自建应用信息</div>
        <div class="body-list">
          <span class="nunm">小提醒：请注意检查不要有空格</span>
          <br />
          <el-button type="primary">前往创建应用</el-button>
        </div>
      </div>
      <div class="list">
        <div class="name">第三步：配置聊天工具栏链接</div>
        <div class="body-list">
          <span class="nunm">小提醒：请注意链接一定要是https开头的协议</span>
          <br />
          <el-button type="primary">前往创建应用</el-button>
        </div>
      </div>
      <div class="list">
        <div class="name">第四步：设置应用可信域名</div>
        <div class="body-list">
          <span
            >在应用设置页，将 qy.weijub.com
            设置为可信域名，并下载校验文件保存到电脑本地后，在此处上传。查看图示</span
          >
          <br />
          <el-button type="primary">前往创建应用</el-button>
          <br />
          <span
            >请上传txt格式的校验文件，用于完成域名归属验证。否则无法正常使用聊天侧边栏。</span
          >
        </div>
      </div>
      <div class="list">
        <div class="name">第五步：配置应用权限</div>
        <div class="body-list">
          <span>客户联系-客户-点击展开API-可调用应用-修改。查看图示</span>
          <br />
          <el-button type="primary">前往创建应用</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "mine",
  data() {
    return {
      list: "聊天工具栏",
    };
  },
};
</script>
<style scoped>
.nav {
  height: 5.0rem;
  background-color: rgb(255, 242, 219);
  border: 1px solid #ffdda6;
  line-height: 5.0rem;
}
.list {
  background-color: #f8f8f8;
  margin-top: 3.0rem;
}
.name {
  height: 10.0rem;
  background-color: #dcdcdc;
  line-height: 10.0rem;
  padding-left: 5.0rem;
}
.body-list {
  padding: 5.0rem;
}
.body-list > span {
  display: inline-block;
  margin-bottom: 2.0rem;
}
.nunm {
  color: red;
}
.body-list > span:nth-child(5) {
  color: #999;
  margin-top: 2.0rem;
}
</style>
